/**
 * Page + funnel analytics via Google Analytics 4 (gtag.js).
 *
 * The gtag tag is already loaded in index.html (measurementId G-4R82SHE755),
 * exactly like the marketing site — so there's no SDK, no env vars, and no
 * init here. Page views are logged on route changes; funnel events at the key
 * Creative Studio steps. If gtag isn't present (blocked, or running outside the
 * browser), everything no-ops. Data lands in your Firebase / GA4 console.
 */

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

/**
 * Log a page view. Path only — never the query string, so we never log the
 * Stripe session_id or other tokens.
 */
export function trackPageView(path, title) {
  gtag('event', 'page_view', {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: title || document.title,
  });
}

/** Log a custom funnel / interaction event. */
export function trackEvent(name, params = {}) {
  gtag('event', name, params);
}

/**
 * Send a Meta Pixel event (no-ops if the pixel isn't loaded). The pixel is
 * initialized in index.html (same dataset as the marketing site). Pass an
 * { eventID } in options so the server-side CAPI event can be de-duplicated.
 */
export function metaTrack(name, params = {}, options = {}) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', name, params, options);
  }
}

/**
 * Read Meta's _fbp / _fbc cookies so the server-side Conversions API can match
 * its events to the browser pixel. Returns { fbp, fbc } (values may be undefined).
 */
export function getMetaCookies() {
  if (typeof document === 'undefined') return {};
  const read = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
  };
  return { fbp: read('_fbp'), fbc: read('_fbc') };
}
